import dayjs from 'dayjs';
import { IMockupGenerationLogsQueryParams } from '../../../api/mockupGenerationLogs';

/** Last 7 days (UTC dates) — the endpoint requires a date range or an id filter. */
export const DEFAULT_MOCKUP_GENERATION_LOGS_PARAMS = (): IMockupGenerationLogsQueryParams => ({
    page: 1,
    limit: 50,
    sortDirection: 'DESC',
    tsMin: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
    tsMax: dayjs().format('YYYY-MM-DD'),
    eventId: null,
    tempEventId: null,
    customerId: null,
    template: null,
    status: null,
    httpStatus: null,
    modelType: null,
    serverHost: null,
    responseMode: null,
    total: 0,
});
